import { removeItem } from "@/utils/va-order-test/testAndPanelSelection";
import { listPatientsByAddress } from "@/api/va-order-page/orderTest.js";
import store from "@/store";

const familyDiscount = {
  namespaced: true,
  state: {
    familyMembers: [],
    familyDiscountOrders: [],
    isClickAddFamilyMember: false,
  },
  getters: {
    selectedFamilyMembers(state) {
      return state.familyMembers.filter(member => member.isSelected);
    },
    gutZoomer(state, getters, rootState, rootGetters) {
      return rootGetters["orderTest/tests/testList"].find(test => [836, 61].includes(test.id));
    },
    /**
     * family discount eligible rules:
     * 1. available in US
     * 2. available for complete address
     * 3. available if non-blood kit is ship to patient
     * 4. available for gut zoomer
     */
    familyDiscountEligible(_, getters, rootState) {
      let patient = rootState.orderTest.order.patient;
      if (!patient) {
        return false;
      }
      let { streetAddress, city, state, zipcode, country } = patient;
      if (!streetAddress || !city || !state || !zipcode || (country && country.toUpperCase() !== "US")) {
        return false;
      }
      let deliveryMethod = rootState.orderTest.order.deliveryMethod;
      if (!deliveryMethod) {
        return false;
      }
      if (deliveryMethod.nonBlood !== "shipToPatient") {
        return false;
      }
      let isPricecalculator = window.location.href.includes("/pricecalculator");
      return !isPricecalculator && getters.gutZoomer && getters.gutZoomer.isSelect ? true : false;
    }
  },
  mutations: {
    SET_FAMILY_MEMBERS(state, members) {
      state.familyMembers = members;
    },
    SET_FAMILY_DISCOUNT_ORDERS(state, orders) {
      state.familyDiscountOrders = orders;
    },
    REMOVE_FAMILY_DISCOUNT_ORDER(state, order) {
      removeItem(order, state.familyDiscountOrders);
    },
    DESELECT_FAMILY_MEMBER(state, id) {
      let member = state.familyMembers.find(member => member.id === id);
      if (member) {
        member.isSelected = false;
      }
    },
    ADD_FAMILY_MEMBER(state, member) {
      let existingFamilyMember = state.familyMembers.find(m => m.id === member.id);
      if (existingFamilyMember) {
        existingFamilyMember.isSelected = true;
      } else {
        state.familyMembers.push(member);
      }
    },
    SET_IS_CLICK_ADD_FAMILY_MEMBER(state, isClick) {
      state.isClickAddFamilyMember = isClick;
    }
  },
  actions: {
    async setFamilyMembers({ commit, dispatch }, familyMembers) {
      if (familyMembers) {
        commit('SET_FAMILY_MEMBERS', familyMembers);
        dispatch('setFamilyDiscountOrders'); // set family discount orders when family members are changed
        return;
      }
      try {
        const patient = JSON.parse(sessionStorage.getItem("patient"));
        const clinicId = store.state.orderTest.user.userInfo?.clinic_id;
        if (!patient || !clinicId) {
          console.error("Missing patient info or clinic ID.");
          commit('SET_FAMILY_MEMBERS', []);
          return;
        }
        let { streetAddress, apt_po, city, state, zipcode, country } = patient;
        if (!streetAddress || !city || !state || !zipcode || (country && country.toUpperCase() !== "US")) {
          commit('SET_FAMILY_MEMBERS', []);
          return;
        }
        const requestBody = {
          street_address: streetAddress || "",
          apt_po: apt_po || "",
          city: city || "",
          state: state || "",
          zipcode: zipcode || "",
          country: country || "",
          clinic_id: clinicId
        };
        const { data } = await listPatientsByAddress(requestBody);
        const patients = data?.patients || [];
        const formatted = Array.isArray(patients)
          ? patients
              .filter(p => p.id.toString() !== patient.id.toString()) // Exclude the current patient
              .map(p => {
                const birthDate = p.dob;
                return {
                  id: Number(p.id),
                  name: [p.first_name, p.middle_name, p.last_name].filter(Boolean).join(" "),
                  gender: p.gender,
                  birthDate,
                  isSelected: false
                };
              })
          : [];

        commit('SET_FAMILY_MEMBERS', formatted);
        dispatch('setFamilyDiscountOrders'); // set family discount orders when family members are changed
      } catch (err) {
        console.error("Failed to fetch family members:", err);
        commit('SET_FAMILY_MEMBERS', []);
      }
    },
    setFamilyDiscountOrders({ commit, getters }) {
      if (!getters.gutZoomer) {
        return;
      }
      let { id, price, displayName } = getters.gutZoomer;
      let tests = [{ id, price: price * 0.8, originalPrice: price, displayName }];
      let orderInfos = getters.selectedFamilyMembers.map(member => {
        return {
          patient: member,
          tests, 
          price: tests.reduce((acc, test) => acc + test.price, 0),
        }
      });
      commit('SET_FAMILY_DISCOUNT_ORDERS', orderInfos);
    },
    removeFamilyDiscountOrder({ commit }, order) {
      commit('REMOVE_FAMILY_DISCOUNT_ORDER', order);
    },
    deselectFamilyMember({ commit }, id) {
      commit('DESELECT_FAMILY_MEMBER', id);
    },
    addFamilyMember({ commit }, member) {
      commit("ADD_FAMILY_MEMBER", member);
    },
    setIsClickAddFamilyMember({ commit }, isClick) {
      commit("SET_IS_CLICK_ADD_FAMILY_MEMBER", isClick);
    }
  }
};

export default familyDiscount;